<script>
import email_icon from "@/components/svg/email_icon.vue";
import phone_icon from "@/components/svg/phone_icon.vue";
import telegram_icon from "@/components/svg/telegram_icon.vue";
import viber_icon from "@/components/svg/viber_icon.vue";
import whatsApp_icon from "@/components/svg/whatsApp_icon.vue";
import logotype_footer from "@/components/svg/logotype_footer.vue";
import YandexMap_icon from "@/components/svg/yandex-map_icon.vue";
import GoogleMap_icon from "@/components/svg/google-map_icon.vue";

export default {
  name: "footer_component",
  components: {
    GoogleMap_icon,
    YandexMap_icon,
    logotype_footer,
    whatsApp_icon, viber_icon, telegram_icon, phone_icon, email_icon
  }
}
</script>

<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__sitemap">
      </div>
      <div class="footer__logo_and_contacts">
        <div class="footer__lac_column column kotlov_logo">
          <a href="tel:+375297837777" class="wrapper">
            <logotype_footer></logotype_footer>
          </a>
        </div>
        <div class="footer__lac_column column contacts">
          <p class="footer__lac_title">
            Контакты
          </p>
          <div class="footer__lac_items">
            <div class="footer__lac_item">
              <phone_icon class="footer__icon"></phone_icon>

              <a class="footer__main_info_text" href="tel:+375297837777">
                <span itemprop="telephone">+375 (29) 783-77-77</span>
                <viber_icon class="footer__icon" link="viber://chat?number=%2B375297837777"></viber_icon>
                <whatsApp_icon class="footer__icon" link="https://wa.me/+375297837777"></whatsApp_icon>
                <telegram_icon class="footer__icon" link="https://t.me/KotlovCity"></telegram_icon>
              </a>

            </div>
            <div class="footer__lac_item">
              <email_icon class="footer__icon"></email_icon>
              <a itemprop="email" class="footer__main_info_text"
                 href="mailto:7797.by@gmail.com">7797.by@gmail.com</a>
            </div>
            <div class="footer__lac_item">
              <address class="footer__main_info_text address" itemprop="geo" itemscope
                       itemtype="https://schema.org/GeoCoordinates">
                <div style="display: flex; gap: 1rem;">
                  <div style="display: flex; gap: 0.2rem;">
                    <YandexMap_icon location="https://yandex.by/maps/org/kotlov_siti/138185270591/?ll=23.848824%2C53.684847&z=17.01"/>
                    <GoogleMap_icon location="https://www.google.com/maps/place/%D0%9A%D0%BE%D1%82%D0%BB%D0%BE%D0%B2+%D0%A1%D0%B8%D1%82%D0%B8+%E2%94%82+%D0%91%D0%BE%D0%B9%D0%BB%D0%B5%D1%80%D1%8B,+%D0%BA%D0%BE%D1%82%D0%BB%D1%8B,+%D0%BE%D1%82%D0%BE%D0%BF%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5/@53.6848332,23.8462739,17z/data=!3m1!4b1!4m6!3m5!1s0x46dfd66ccfae975b:0xddcbc90d0b7cf0f1!8m2!3d53.6848301!4d23.8488488!16s%2Fg%2F11gfn63pbx?hl=ru&entry=ttu&g_ep=EgoyMDI1MDUxMy4xIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D"/>
                  </div>
                  <span itemprop="streetAddress">г.Гродно ул. Красноармейская 69</span>
                </div>

                <div style="display: flex; gap: 1rem; margin-top: 0.5rem; align-items: center;">
                  <div style="display: flex; gap: 0.2rem; align-items: center;">
                    <YandexMap_icon location="https://yandex.by/maps/157/minsk/house/Zk4Ycw9gTUYCQFtpfXVydHRrZg==/inside/?ll=27.580150%2C53.935890&tab=inside&z=19.37"/>
                    <GoogleMap_icon location="https://www.google.com/maps/place/%D0%A2%D0%A6+%C2%ABVIESSMANN%C2%BB,+%D1%83%D0%BB.+%D0%9C%D0%B0%D0%BA%D1%81%D0%B8%D0%BC%D0%B0+%D0%91%D0%BE%D0%B3%D0%B4%D0%B0%D0%BD%D0%BE%D0%B2%D0%B8%D1%87%D0%B0+153+%D0%91,+%D0%9C%D0%B8%D0%BD%D1%81%D0%BA,+%D0%9C%D0%B8%D0%BD%D1%81%D0%BA%D0%B0%D1%8F+%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C+220040/@53.9358509,27.5756566,17z/data=!3m1!4b1!4m10!1m2!2m1!1zPtCzLiDQnNC40L3RgdC6LCDRg9C7LiDQkdC-0LPQtNCw0L3QvtCy0LjRh9CwLCAxNTPQkQ!3m6!1s0x46dbcf6e28fe977f:0x3d7a0e9c3170c002!8m2!3d53.9358478!4d27.5805275!15sCjQ-0LMuINCc0LjQvdGB0LosINGD0LsuINCR0L7Qs9C00LDQvdC-0LLQuNGH0LAsIDE1M9CRkgEKc3VicHJlbWlzZeABAA!16s%2Fg%2F11x5kt45yc?hl=ru&entry=ttu&g_ep=EgoyMDI1MDUxMy4xIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D"/>
                  </div>
                  <span itemprop="streetAddress">г. Минск, ул. Богдановича, 153Б</span>
                </div>
                <meta itemprop="latitude" content="53.684850"/>
                <meta itemprop="longitude" content="23.848834"/>
              </address>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped lang="scss">
@import "@/assets/base";

.footer {
  width: 100%;
  background-color: $dg2;
  color: $text_color;
  margin-top: 140px;
}

.container {
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  padding: 50px 60px;
}

@media screen and (min-width: 675px) and (max-width: 1000px) {
  .container {
    padding: 50px 0;
  }
}

@media screen and (max-width: 550px) {
  .container {
    padding: 50px 20px;
  }
}

@media screen and (max-width: 1480px) {
  .container {
    flex-wrap: wrap;
    justify-content: center;
  }
}

.footer__sitemap, .footer__logo_and_contacts {
  display: flex;
  flex-direction: row;
}

@media screen and (max-width: 767px) {
  .footer__sitemap {
    flex-wrap: wrap;
    justify-content: center;
    flex-shrink: 1;
  }
}


.footer__sitemap {
  flex-grow: 3;
}

.footer__logo_and_contacts {
  flex-grow: 7;
}

@media screen and (max-width: 767px) {
  .footer__logo_and_contacts {
    flex-wrap: wrap-reverse;
    flex-shrink: 1;
  }
}

.column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}

.footer__sitemap_column {
  box-sizing: border-box;
  padding-right: 20px;
}

.footer__sc_title, .footer__lac_title, .footer__sc_items, .footer__lac_items {
  font-size: 24px;
  font-weight: 400;
  font-family: "Raleway", sans-serif;
}

.footer__sc_items, .footer__lac_items {
  margin-top: 20px;
}

.footer__sc_items {
  margin-left: 20px;
}

.footer__sc_item:before {
  content: "\00B7";
  margin-right: 5px;
  font-weight: 900;
  text-decoration: none;
}


.contacts {
  box-sizing: border-box;
  padding-left: 60px;
  display: flex;
  flex-grow: 1;
}

@media screen and (max-width: 1480px) {
  .contacts {
    padding-left: 0;
    width: 50%;
  }
}

.footer__lac_items, .footer__lac_item {
  margin-top: 20px;
}

@media screen and (max-width: 767px) {
  .footer__lac_column, .footer__sitemap_column {
    min-width: 260px;
    margin-top: 40px;
  }
}

.footer__lac_item {
  display: flex;
  align-items: center;
}

.kotlov_logo {
  font-family: "Maitree", serif;
  font-size: 40px;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  line-height: 113%;
  letter-spacing: 4px;

  .city {
    display: flex;
    align-items: center;

    svg {
      margin-left: 10px;
      transform: scale(110%);
    }
  }
}

@media screen and (max-width: 1480px) {
  .kotlov_logo {
    width: 50%;
  }
}


.footer__icon {
  width: 25px;
  height: 25px;
  margin-left: 10px;
}

.footer__main_info_text {
  outline: none;
  text-decoration: none;
  font-size: 24px;
  font-family: "Raleway", sans-serif;
  font-weight: normal;
  font-style: normal;
  color: $text_color;
  padding-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer__main_info_text.address {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}

.footer__sc_item {
  display: flex;
  padding: 0;
  margin-top: 5px;
}
</style>